export enum ProjectState {
    IN_PROGRESS = 0,
    WEB_DEVELOPMENT = 1,
    WEB_DESIGNER = 2,
    FINISHED = 3,
};
